<template>
    <button
        class="btn-option-phonetic-vowel"
        :class="selectionClass">
        <span class="btn-option-phonetic-vowel__text">{{ optionText }}</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            featureType:    { type: String, default: 'lorem' },
            optionSlug:     { type: String, default: 'lorem' },
            optionText:     { type: String, default: 'Lorem' },
        },

        computed: {
            selectionClass(){
                let answerDataVowelVariantFeature = this.$store.state.answerData.vowelFeatures.variant;
                if(answerDataVowelVariantFeature === this.optionSlug){
                    return 'btn-option-phonetic-vowel--selected';
                }
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-option-phonetic-vowel.css"></style>